// extracted by css-extract-rspack-plugin
export default {"statisticsGroup":"StatisticsGroup-module__statisticsGroup__pGXX8","statisticWrapper":"StatisticsGroup-module__statisticWrapper__c9NBt","body":"StatisticsGroup-module__body__DEPVO"};